// localStorage persistence for the Studio's chat history. Capped at
// 30 turns so we don't grow unbounded — last session's conversation is
// what matters; older turns are noise.

import type { ChatTurn } from '../api/client';

const KEY = 'stamps:lastChat:v1';
const MAX_TURNS = 30;

export function loadPersistedChat(): ChatTurn[] | null {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as ChatTurn[]) : null;
  } catch { return null; }
}
export function savePersistedChat(turns: ChatTurn[]): void {
  try { localStorage.setItem(KEY, JSON.stringify(turns.slice(-MAX_TURNS))); } catch { /* quota */ }
}
export function clearPersistedChat(): void {
  try { localStorage.removeItem(KEY); } catch { /* */ }
}